import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { FinalGradeExtended } from './final-grade-extended.model';
import { FinalGrade } from './final-grade.model';

export class FinalGradeStateModel extends EntityStateModel<FinalGrade> {
    userFinalGrades?: FinalGradeExtended[];
}
